import {View, Text}  from 'react-native'

import {estilos} from '../util/estilos'



import cores from '../util/cores'


export function semDados(icon, texto, tamannho_icon=40) {
																																	
    return(
		<View style={{justifyContent: 'center', alignItems:'center', flex:1}}>
			<View style={{marginTop:25}}/>
			
			<View style={{marginTop:100}}/>
			<Text style={[estilos.rotulo_padrao, {color:cores.fonte_escura}]}>{texto}</Text>
			<View style={{marginTop:100}}/>
		</View>
	)  
} 



